export default __webpack_public_path__ + "static/media/Stack.cf6401ff.png";